<script setup lang="ts">
import { RouterView } from "vue-router";

import RsHeader from "@/components/RsHeader.vue";
import RsNav from "@/components/RsNav.vue";
import RsFooter from "@/components/RsFooter.vue";
import useConfig from "./composables/config";
import { rsSearchError } from "@/composables/use-rs-search";
import Alert from "@/components/Alert.vue";

const { config } = useConfig();

const prefersDarkScheme = window.matchMedia(
  "(prefers-color-scheme: dark)"
).matches;

const cssId = "css_scheme_link";
if (!document.getElementById(cssId)) {
  const suffix = prefersDarkScheme ? "_dark" : "";
  var link = document.createElement("link");
  link.href = config.viteBasePath + `scheme_${config.cssPrefix}${suffix}.css`;
  link.rel = "stylesheet";
  link.id = cssId;
  document.getElementsByTagName("head")[0].appendChild(link);
}
</script>

<template>
  <RsHeader class="flex-shrink-0" />
  <RsNav class="flex-shrink-0" />
  <div v-if="rsSearchError" class="flex grow justify-center">
    <Alert type="danger" class="w-rs-content mt-rs-padding-main">
      {{ `Error encountered: "${rsSearchError}". Try reloading the page.` }}
    </Alert>
  </div>
  <div class="grow flex flex-col p-rs-padding-main mx-auto">
    <router-view />
  </div>
  <RsFooter class="flex-shrink-0" />
</template>

<style></style>
